import HeaderBar from "../../../components/header/headerBar";
import { SearchField } from "../../../components/textfield";
import MainButton from "../../../components/button/mainButton";
import IconMdi from "@mdi/react";
import { mdiPlus, mdiPencilCircle, mdiDelete } from "@mdi/js";
import { useHistory } from "react-router";
import { Modal, Table } from "antd";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { numberWithCommas } from "../../../helpers/functions";
import axios from "axios";
import moment from "moment";


const Promotion = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [data, setData] = useState<any>([]);
  const [searchKeyItem, setSearchKeyItem] = useState<string>("");
  const columns = [
    {
      title: "",
    },
    {
      title: "Code",
    },
    {
      title: "Name",
    },
    {
      title: "ProPrice",
      align: "center",
    },
    {
      title: "ProType",
      align: "center",
    },

    {
      title: "Category",
      align: "center",
    },
    {
      title: "DateStart / DateEnd",
      align: "center",
    },
    {
      title: "Active",
      align: "center",
      colspan: 2,
    },
  ];
  const columns2 = [
    {
      title: "",
      dataIndex: "rowCount",
      width: "5%",
      align: "center" as const,
      render: (text: any, record: any, index: number,) => index + 1,
    },
    {
      title: "Code",
      dataIndex: "code",
      render: (text: any) => text,
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text: any) => {
        return text;
      },
    },
    {
      title: "ProPrice",
      dataIndex: "promotionPrice",
      align: "center" as const,
      render: (text: any) => numberWithCommas(text),
    },
    {
      title: "ProType",
      dataIndex: "promotionType",
      align: "center" as const,
      render: (text: any, record: any) => promotiontype[record?.promotionType]
    },
    {
      title: "Category",
      dataIndex: "date",
      align: "center" as const,
      width: "100px",
      render: (text: any, record: any) => record.isSelectProductCategoryAll === false
        ? record?.productCategoryDetail?.name
        : "All",
    },
    {
      title: "DateStart / DateEnd",
      dataIndex: "date",
      align: "center" as const,
      width: "150px",
      render: (text: any, record: any) => <>
        {moment(record?.startDate).format("DD-MM-YYYY")}
        <br />
        {moment(record?.endDate).format("DD-MM-YYYY")}</>
    },


    {
      title: "Action",
      align: "center" as const,
      colspan: 2,
      width: "100px",
      render: (text: any, record: any) => <>
        <div className="row">
          <div className="col" onClick={() => history.push(`promotion/${record._id}/view`)}> <IconMdi path={mdiPencilCircle} size="24" color="#5BAEA9" /></div>
          <div className="col" onClick={() => showDeleteConfirm(record._id, record.name)}><IconMdi path={mdiDelete} size="24" color="#FF6760" /></div>
        </div>
      </>,
    },
  ];
  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // deleteData(id);
        axios.delete(`/promotions/${id}`).then((res) => {
          let index = data.findIndex((item: any) => item._id === id);
          let promotion = data;
          promotion.splice(index, 1);
          getPromotion();
        });
      },
      width: "fit-content",
    });
  }
  useEffect(() => {
    getPromotion();
  }, []);
  const getPromotion = () => {
    axios.get(`/promotions`).then((res) => {
      setData(res?.data?.data);
    });
  };
  const promotiontype: any = {
    membership: "MEMBERSHIP",
    normal_limit: "วงเงินปกติ (Fix % รายการ)",
    buffet_special: "Buffet Special",
    buffet_specific_treatment: "Buffet Specific Treaement",
    package: "จัดแพคเกจ",
    free_credit_price: "วงเงินแถม/Free Credit Price",
  };

  const searchItem = () => {
    if (searchKeyItem.length >= 1) {
      let calculateData: any = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]["code"]?.substr(0, searchKeyItem).toUpperCase() === searchKeyItem.toUpperCase()) {
          calculateData.push(data[i]);
        } else if (data[i]["code"]?.toUpperCase().indexOf(searchKeyItem.toUpperCase()) > -1) {
          calculateData.push(data[i]);
        } else if (data[i]["name"]?.substr(0, searchKeyItem).toUpperCase() === searchKeyItem.toUpperCase()) {
          calculateData.push(data[i]);
        } else if (data[i]["name"]?.toUpperCase().indexOf(searchKeyItem.toUpperCase()) > -1) {
          calculateData.push(data[i]);
        }
      }
      return calculateData;
    } else {
      return data;
    }
  };
  return (
    <div>
      <HeaderBar title="PROMOTION" />
      <div style={{ padding: "10px 40px" }}>
        <SearchField
          placeholder="Search for Promotion Code/Name"
          color="#fff"
          onChange={(e: any) => setSearchKeyItem(e.target.value)}
        />
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title="Create Promotion"
            onClick={() =>
              history.push(`/setting/service/promotion/promotioncreate`)
            }
          >
            <IconMdi path={mdiPlus} size="24" color="#FFFFFF" />
          </MainButton>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table
            columns={columns2}
            dataSource={searchItem()}
            rowKey="_id"
            bordered
            scroll={{ x: 100 }}
            size="small"
          ></Table>
          {/* <Table header={columns}>
            {searchItem().map((item: any, index: number) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="8%">{item?.code}</TableColumn>
                <TableColumn width="12%">{item?.name}</TableColumn>
                <TableColumn width="8%" align="center">
                  <NumberFormat
                    value={Number(item?.promotionPrice).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                </TableColumn>
                <TableColumn width="12%" align="center">
                  {promotiontype[item?.promotionType]}
                </TableColumn>
                <TableColumn width="8%" align="center">
                  {item.isSelectProductCategoryAll === false
                    ? item?.productCategoryDetail?.name
                    : "All"}
                </TableColumn>

                <TableColumn width="8%" align="center">
                  {moment(item?.startDate).format("DD-MM-YYYY")}
                  <br />
                  {moment(item?.endDate).format("DD-MM-YYYY")}
                </TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    onClick={() => history.push(`promotion/${item._id}/view`)}
                  >
                    <IconMdi path={mdiPencilCircle} size="24" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn
                  width="3%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.name);
                  }}
                >
                  <IconMdi path={mdiDelete} size="24" color="#FF6760" />
                </TableColumn>
              </tr>
            ))}
          </Table> */}
        </div>
      </div>
    </div>
  );
};
export default Promotion;
